import currencies from 'component/converter/countries.json'
import store from '../store'

function isInt(n) {
  return n % 1 === 0;
}

class CurrencyHelper {

  formartCurrencies (compareWithCountry) {
    this.currencies = store.state.currencies
    return Object.keys(this.currencies).map((v) => {
      let currency = v.substr(3, v.length)
      return {
        flag: `<div class="currency-flag currency-flag-${currency.toLowerCase()}"></div>`,
        name: this.getNameOfCurrency(currency),
        label: currency,
        value: `1 ${compareWithCountry} = ${this.convert(compareWithCountry, currency, 1)} ${currency}`
      }
    })
  }

  getNameOfCurrency (currency) {
    return currencies[currency]
  }

  convert (currencyFrom, currencyTo, valueFrom) {
    let valueOfCurrencyFrom = this.getValueOfCurrency(currencyFrom)
    let valueOfCurrencyTo = this.getValueOfCurrency(currencyTo)
    let valueTo
    if (!isNaN(valueFrom)) {
      let result = (valueOfCurrencyTo / valueOfCurrencyFrom * valueFrom)
      if (isInt(result)) {
        valueTo = result
      } else {
        valueTo = result
      }
    }
    return valueTo
  }

  customConvert (valueOfCurrencyFrom, valueOfCurrencyTo, valueFrom) {
    let valueTo
    if (!isNaN(valueFrom)) {
      let result = (valueOfCurrencyTo / valueOfCurrencyFrom * valueFrom)
      if (isInt(result)) {
        valueTo = result
      } else {
        valueTo = result
      }
    }
    return valueTo
  }

  getValueOfCurrency (currency) {
    this.currencies = store.state.currencies
    if (currency == 'USD') {
      return 1
    }
    let data
    Object.keys(this.currencies).forEach((key) => {
      if (key.indexOf(currency) == 3) {
        data = this.currencies[key]
      }
    })
    return data
  }

}

export default new CurrencyHelper()


// WEBPACK FOOTER //
// ./src/helper/currency.js